import React, { useContext, useState } from "react";
import "../Styles/HistoryUploadCss.css";
import userContext from "../../../../context/users/UserContext";
import { USERTYPES } from "../../../../constants/Constants";
import { FileUploader } from "react-drag-drop-files";
import LoadingBar from "react-top-loading-bar";
import {
  DefaultButton,
  IconButton,
  PrimaryButton,
  TextField,
  Checkbox,
} from "@fluentui/react";
import { useTranslation } from "react-i18next";
import DeleteIcon from "../../../../components/SVGComponents/DeleteIcon";
import { historyDownload } from "../../../../service/StudyViewerService";
import Download from "../../../../components/SVGComponents/Download";
import EyeIcon from "../../../../components/SVGComponents/EyeIcon";
import studyReportContext from "../../../../context/studyreport/StudyReportContext";
import themeContext from "../../../../context/theme/ThemeContext";
import loaderContext from "../../../../context/loader/LoaderContext";
import { t } from "i18next";
import CustomSelect from "../../../../components/CustomSelect";
import SubModalityWithView from "../../../../components/SubModalityWithView";

const UploadHistoryBody = (props) => {
  const { roles, isActiveData } = useContext(userContext);
  const { getThemeColor,themeName,getScrollBarStyleForTheme } = useContext(themeContext);
  const { ref, setLoaderRunning } = useContext(loaderContext);
  const [t] = useTranslation();
  const [moreFiles, setMoreFiles] = useState(1);
  const { setAlertSuccessModal, alertSuccessModal } =
    useContext(studyReportContext);
  const showUpload = true && !props.isChild ? true : false;
  const className = `secondBlock ${themeName === 'light' ? 'common-modal-scroll-light' : 'common-modal-scroll'}`;


  const checkboxStyle = {
    checkbox: {
      borderColor: "#A19F9D",
      height: "15px",
      width: "15px",
    },
  };

  function getFileExtension(filename) {
    // get file extension
    const extension = filename.split(".").pop();
    return extension;
  }

  const getFileName = (str) => {
    let s = str.lastIndexOf("/");
    if (s != -1) {
      return str.substring(s + 1);
    }
    return "";
  };

  const getTechnicianName =(contactList, selectedContact)=>{
    for(let i = 0; i < contactList.length; i ++){
      if(contactList[i].value == selectedContact){
        return contactList[i].label;
      }
    }
    return "";
  }

  const printPreviewHistoryDoc = async (historyDoc) => {
    let n = historyDoc.indexOf("/");
    let result = historyDoc.substring(n + 1);
    let extension = getFileExtension(getFileName(result));
    let body = {
      studyId: props.studyId,
      filePath: result,
    };
    setLoaderRunning(true);
    ref.current.continuousStart();
    try {
      let res = await historyDownload(body, extension);
      setLoaderRunning(false);
    } catch (e) {
      setLoaderRunning(false);
    }
  };

  function getFileExtension(filename) {
    // get file extension
    const extension = filename.split(".").pop();
    return extension;
  }

  const fileTypes = [
    "JPEG",
    "jpeg",
    "PNG",
    "png",
    "text/plain",
    "PDF",
    "pdf",
    "JPG",
    "jpg",
    "TXT",
    "txt",
    "DOC",
    "doc",
    "DOCX",
    "docx",
  ];
  const addMoreFiles = () => {
    setMoreFiles(moreFiles + 1);
  };

  const AddMoreButtonStyles = {
    root: {
      label: {
        fontWeight: "100",
      },
    },
  };

  const handleSelectAllCheckBox = (e) => {
    const isChecked = e.target.checked;
    const checkboxes = document.querySelectorAll("."+`${themeName==='light'?'delete-checkbox-light':'delete-checkbox-dark'}`);
    checkboxes.forEach(checkbox => {
      checkbox.checked = isChecked;
    });
  }

  const disableTextField = {
    field: {
      borderColor: "gray !important",
      background: "transparent !important",
    },
    fieldGroup: {
      borderColor: "gray !important",
      background: "transparent !important",
    },
  };
  return (
    <div className="history-upload-modal-container">
      <div
        style={{
          padding: "auto",
          height: "100%",
          width: "100%",
          zIndex: "99999",
          display: `${props.loadingTopLoader ? "flex" : "none"}`,
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "black",
          opacity: "0.8",
          position: "absolute",
          top: "0",
          left: "0",
        }}
      >
        <LoadingBar
          ref={props.loadRef}
          color="#0085FF"
          height={5}
          // progress={progress}
          onLoaderFinished={() => {
            props.setLoadingTopLoader(false);
          }}
          containerStyle={{
            backgroundColor: "black",
            opacity: "0.8",
            position: "absolute",
            top: "0",
            left: "0",
          }}
          loaderSpeed={1000}
          transitionTime={1000}
        />
        {/* <div
        style={{
          color: "white",
          position: "absolute",
          top: "50%",
          width: "100%",
          textAlign: "center",
        }}
      >
        <h1>SAMPLE TEXT</h1>
      </div> */}
      </div>

      <div className={"secondBlock "+getScrollBarStyleForTheme(themeName,"common-modal-scroll")}>
        <div className="clinical-note">
          <label
            style={{ color: getThemeColor("primary-color") }}
            className="label"
            htmlFor="clinicalNote"
          >
            {t("history-upload.title")}
          </label>
          {showUpload && roles[0] !== USERTYPES.RADIOLOGIST && roles[0] !== USERTYPES.TYPIST ? (
            <TextField
              className="history-textArea"
              name="clinicalNote"
              placeholder={t("history-upload.type-your-comment-here")}
              onChange={props.handleChange}
              value={props.values.clinicalNote}
              multiline
              rows={3}
            />
          ) : (
            <TextField
              className="history-textArea is-disabled-clinical-notes"
              name="clinicalNote"
              styles={disableTextField}
              value={props.values.clinicalNote}
              disabled
              multiline
              rows={3}
            />
          )}
        </div>
        {showUpload &&
        (roles[0] == USERTYPES.FIRMTECHNICIAN ||
          roles[0] == USERTYPES.FIRMDOCTOR) ? (
          <>
            <TechnicianContact
              technicianContactList={props.technicianContactList}
              // selectedTechnicianContact={props.selectedTechnicianContact}
              selectedTechnicianContact={props.values.technicianContactId}
              handleTechinicianContactChange={
                props.handleTechinicianContactChange
              }
            ></TechnicianContact>
          </>
        ) : (
          <>
            {props.selectedTechnicianContact && (
              <div
                style={{
                  color: getThemeColor("primary-color"),
                  display: "flex",
                  alignItems: "flex-start",
                  width: "100%",
                  flexDirection: "column",
                  gap: "5px",
                  marginBottom: "20px"
                }}
              >
                <span className="label" style={{ marginBottom: "0px", whiteSpace : "nowrap", marginRight : "10px"}}>
                  {t("history-upload.technician-contact")}
                </span>
                <span style={{wordBreak : "break-all", lineHeight : "20px", marginLeft: "5px"}} > {getTechnicianName(
                  props.technicianContactList,
                  props.selectedTechnicianContact
                )}</span>
              </div>
            )}
          </>
        )}
        {showUpload && roles[0] !== USERTYPES.RADIOLOGIST && roles[0] !== USERTYPES.TYPIST ? (
          <>
            {process.env.REACT_APP_VDC_PLATFORM === "false" && props.subModalityList?.length > 0 &&
              <div style={{ marginBottom: "20px" }}>
                {/* <div
                  style={{ color: getThemeColor("primary-color") }}
                  className="upload-history-body-label"
                >
                <div>
                  {t("heading.sub-modality")}
                </div>
                </div> */}
                <div style={{ marginLeft: "0px" }}>
                  <SubModalityWithView 
                  modalityId = {props.modalityId}
                  subModalityList = {props.subModalityList}
                  selectedSubModalityIds={props.selectedSubModalityIds || []}
                  setSelectedSubModalityIds={props.setSelectedSubModalityIds}
                  setChoosenSubModality={props.setChoosenSubModality}
                  setStudyDescription={props.setStudyDescription}
                  customDescription={props.customDescription}
                  setCustomDescription={props.setCustomDescription}/>
                </div>
              </div>
            }
            <div className="upload-note">
              <label
                style={{ color: getThemeColor("primary-color") }}
                className="label"
                htmlFor="uploadNote"
              >
                {t("history-upload.upload-note")}
              </label>
              <div className="uploaderDiv">
                {/* {moreFiles.map(()=> */}
                <div className="fileuploader-main">
                  <FileUploader
                    handleChange={props.handleFileUploadChange}
                    name="files"
                    className="filesUploader-label"
                    types={fileTypes}
                    onTypeError={(err) => {
                      setAlertSuccessModal(() => {
                        const newItem = { ...alertSuccessModal };
                        newItem.show = true;
                        newItem.heading = "Alert";
                        newItem.isError = false;
                        newItem.isSuccess = false;
                        newItem.isWarning = true;
                        newItem.description = t(
                          "string-literals.not-supported-files"
                        );
                        return newItem;
                      });
                    }}
                    label={t("history-upload.drag-or-browse-files")}
                    multiple={true}
                    children={
                      <p
                        className="fileUploader"
                        style={{ color: getThemeColor("primary-color") }}
                      >
                        {t("history-upload.drag-or-browse-files")}
                      </p>
                    }
                  />
                </div>
                {/* )} */}
                {/* <PrimaryButton text='Add more files' onClick={addMoreFiles} style={{fontWeight:'400'}}/> */}
              </div>
            </div>
            <div className="fileNames-container">
              {props.fileNames.map((name, index) => (
                <div className="file-name" key={index}>
                  {name}
                  <IconButton
                    id={index}
                    iconProps={{ iconName: t("button.cancel") }}
                    ariaLabel="Remove file"
                    onClick={() => props.removeUploadedFile(index)}
                    className="file-crossIcon"
                  />
                </div>
              ))}
            </div>{" "}
          </>
        ) : null}
        <div className="historyUploads-div">
          <div style={{
            display: "flex",
            justifyContent: "space-between",
            paddingRight: "60px"
          }}>
          <label
            style={{ color: getThemeColor("primary-color") }}
            className="label"
          >
            {t("history-upload.previous-history-upload")}
          </label>
          {roles[0] !== USERTYPES.RADIOLOGIST && roles[0] !== USERTYPES.TYPIST && props.uploadedFiles?.length > 0 && <input
              type="checkbox"
              id={"checkbox-select-all"}
              style={{height:"15px",width:"15px",cursor:"pointer"}}
              className={themeName==='light'?'delete-checkbox-light':'delete-checkbox-dark'}
              onChange={(e)=>{handleSelectAllCheckBox(e)}}
            />}
            </div>
          <div className="history">
            {props.uploadedFiles &&
              props.uploadedFiles.map((fileObj, index) => (
                <div
                  className={`${
                    showUpload
                      ? "history-file-not-radiologist"
                      : "historyFile-name"
                  }`}
                  key={index}
                  onClick={(ev) => {
                    //if (roles[0] == USERTYPES.RADIOLOGIST || !showUpload) {
                    if (ev.target.className === `${themeName==='light'?'delete-checkbox-light':'delete-checkbox-dark'}`) {
                      return;
                    }
                    ev.stopPropagation();
                    printPreviewHistoryDoc(fileObj.historyReportPath);
                    //}
                  }}
                >
                  {
                    fileObj.historyReportPath.toString().split("/")[
                      fileObj.historyReportPath.toString().split("/").length - 1
                    ]
                  }{" "}
                  <div style={{ display: "flex" }}>
                    {getFileExtension(
                      fileObj.historyReportPath.toString().split("/")[
                        fileObj.historyReportPath.toString().split("/").length -
                          1
                      ]
                    ) == "doc" ||
                    getFileExtension(
                      fileObj.historyReportPath.toString().split("/")[
                        fileObj.historyReportPath.toString().split("/").length -
                          1
                      ]
                    ) == "docx" ? (
                      <span
                        className="study-list-upload-preview-icon"
                        style={{ marginRight: "10px" }}
                      >
                        <Download color="#C1C1C1" />
                      </span>
                    ) : (
                      <span
                        className="study-list-upload-preview-icon"
                        style={{ marginRight: "10px" }}
                      >
                        <EyeIcon color="#C1C1C1" />
                      </span>
                    )}
                    {showUpload && roles[0] !== USERTYPES.RADIOLOGIST && roles[0] !== USERTYPES.TYPIST ? (
                      <div className="icons">
                        <input
                          type="checkbox"
                          id={fileObj.id}
                          className={themeName==='light'?'delete-checkbox-light':'delete-checkbox-dark'}
                          onChange={props.handleChange}
                        />
                        {/* <Checkbox
                      id = {fileObj.id}
                      key={fileObj.id}
                      name={fileObj.id}
                      styles={checkboxStyle}
                      className="delete-checkbox"
                      onChange={props.handleChange}
                    /> */}
                        <div
                          className="study-list-upload-history-deleteIcon"
                          onClick={(ev) => {
                            if (showUpload) {
                              ev.stopPropagation();
                              if(isActiveData)
                                props.handleDeleteConfirmModal(fileObj.id);
                            }
                          }}
                        >
                          <DeleteIcon />
                        </div>
                        {getFileExtension(
                          fileObj.historyReportPath.toString().split("/")[
                            fileObj.historyReportPath.toString().split("/")
                              .length - 1
                          ]
                        ) == "doc" ||
                        getFileExtension(
                          fileObj.historyReportPath.toString().split("/")[
                            fileObj.historyReportPath.toString().split("/")
                              .length - 1
                          ]
                        ) == "docx" ? (
                          <div
                            className="study-list-upload-preview-icon"
                            onClick={(ev) => {
                              if (
                                roles[0] !== USERTYPES.RADIOLOGIST ||
                                !showUpload
                              ) {
                                ev.stopPropagation();
                                printPreviewHistoryDoc(
                                  fileObj.historyReportPath
                                );
                              }
                            }}
                          >
                            {/* <Download color="#C1C1C1" /> */}
                          </div>
                        ) : (
                          <div
                            className="study-list-upload-preview-icon"
                            onClick={(ev) => {
                              if (
                                roles[0] !== USERTYPES.RADIOLOGIST ||
                                !showUpload
                              ) {
                                ev.stopPropagation();
                                printPreviewHistoryDoc(
                                  fileObj.historyReportPath
                                );
                              }
                            }}
                          >
                            {/* <EyeIcon color="#C1C1C1" /> */}
                          </div>
                        )}
                      </div>
                    ) : null}
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UploadHistoryBody;
export const TechnicianContact = ({
  technicianContactList,
  handleTechinicianContactChange,
  selectedTechnicianContact,
}) => {
  const { getThemeColor } = useContext(themeContext);
  return (
    <>
      <div style={{ marginBottom: "20px" }}>
        <div
          style={{ color: getThemeColor("primary-color") }}
          className="upload-study-body-label"
        >
        <div>
           {t("heading.technician-contact")}
        </div>
        </div>
        <CustomSelect
          options={technicianContactList}
          isClearable={true}
          defaultValue={
            selectedTechnicianContact != null
              ? technicianContactList.find(
                  (option) => option.value === selectedTechnicianContact
                )
              : -1
          }
          value={
            selectedTechnicianContact
              ? technicianContactList.find(
                  (option) => option.value === selectedTechnicianContact
                )
              : -1
          }
          label={"Technician Contact"}
          placeholder={"Select technician contact"}
          maxHeight="30px"
          onChange={(item) => {
            // console.log("---Selected Item---", item);
            handleTechinicianContactChange(item);
          }}
          zIndex={1000}
        />
      </div>
    </>
  );
};
